import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';

import { tvSectionList, sectionCategorySorts, gnbId, DEFAULT_SECTION_CODE } from '../../../common/constants';

import Tab from '../common/Tab';
import Category from '../common/Category';

function TopMenu ({ sectionCode = DEFAULT_SECTION_CODE, categoryCode, sortCode, onChange }) {
  const defaultSection = tvSectionList.find(x => x.code === sectionCode);

  const [tvSection, setTvSection] = useState(defaultSection);
  const [currentMenu, setCurrentMenu] = useState({ categoryCode: '', sortCode: '' });

  const [pageChange, setPageChange] = useState(false);

  function changeTvCategoryAndSort ({ sectinoCode = tvSection?.code, categoryCode = '', sortCode = '' }) {
    onChange({ sectinoCode, categoryCode, sortCode });
  }

  return (
    <>
      <h2 className='hide'>TV</h2>
      <div className='contents_area_sorting'>
        <Category
          sectionCode={sectionCode}
          categories={tvSection?.category}
          categoryCode={categoryCode}
          sorts={sectionCategorySorts[tvSection?.sortType]?.searchParamList}
          sortCode={sortCode}
          onChange={changeTvCategoryAndSort}
          pageChange={pageChange}
        />
      </div>
    </>
  );
}

export default TopMenu;
